module.exports = __webpack_public_path__ + "static/moorish-spain-ec205060154129d897acd659235513f6.jpg";